import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import {
  CachedProfile,
  UserEntitlements,
  UserProfile,
} from '@optools/services/operator-gateway/user-lookup/types';
import { selectToolsConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { useTeamsQuery } from '@optools/store/statsApiSlice';

import { ProfileComparison } from './profile-comparison';

export interface UserInfoTableProps {
  cachedEntitlements: UserEntitlements | null | undefined;
  cachedProfile: CachedProfile | undefined | null;
  entitlements: UserEntitlements;
  profile: UserProfile | undefined;
  userId: string;
}

export default function UserInfoTable({
  cachedEntitlements,
  cachedProfile,
  entitlements,
  profile,
  userId,
}: UserInfoTableProps) {
  const { data } = useTeamsQuery();
  const {
    userLookup: { profileEntitlementsEnabled },
  } = useAppSelector(selectToolsConfig);

  const FavoriteTeamCell = () => {
    const cachedTeam = data?.find((team) => team.id === cachedProfile?.favoriteTeam);
    const profileTeam = data?.find((team) => team.id === profile?.favoriteTeam);

    return (
      <ProfileComparison
        cachedValue={cachedTeam?.teamName ?? cachedProfile?.favoriteTeam}
        profileValue={profileTeam?.teamName ?? profile?.favoriteTeam}
      />
    );
  };

  return (
    <div className="space-y-4">
      <h2 className="text-sm font-bold">User Information</h2>
      <Table containerClassName="border rounded-md">
        <TableHeader>
          <TableRow>
            <TableHead>First Name</TableHead>
            <TableHead>Last Name</TableHead>
            <TableHead>Okta ID</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Do Not Sell</TableHead>
            <TableHead>Favorite Team</TableHead>
            <TableHead>Entitlements</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell>
              <p className="text-xs font-normal">{profile?.firstName}</p>
            </TableCell>
            <TableCell>
              <p className="text-xs font-normal">{profile?.lastName}</p>
            </TableCell>
            <TableCell>{userId}</TableCell>
            <TableCell>
              <p className="text-xs font-normal">{profile?.email}</p>
            </TableCell>
            <TableCell>
              <ProfileComparison
                cachedValue={cachedProfile?.doNotSell?.toString()}
                profileValue={profile?.doNotSell?.toString()}
              />
            </TableCell>
            <TableCell>
              <FavoriteTeamCell />
            </TableCell>
            <TableCell>
              {profileEntitlementsEnabled ? (
                <ProfileComparison
                  cachedValue={cachedEntitlements?.join(', ')}
                  profileValue={entitlements?.join(', ')}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <p className="text-xs font-bold">Cached Value:</p>
                  <p className="text-xs font-normal">{cachedEntitlements?.join(', ')}</p>
                </div>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}
